import React, { Component } from "react";
import { connect } from "react-redux";
// import { Link } from 'react-router-dom';
import {
  sendLicenseRequest,
  resetLicenseRequestVideo,
} from "../licensing_redux";
import { sendMessage } from "../../../Pages/Chat/ChatRedux";
import { fetchVIPVideoNote } from "../../../Pages/Video/VideoActions";
import SelectableTags from "../../SelectableTags";
import MySelect from "../../MySelect";
import YouTubeVideo from "../../../Shared/YouTubeVideo";
import GenerateTiktokThumbnail from "../../../Shared/GenerateTiktokThumbnail";
import {
  getLicenseDuration,
  getLicensePrice,
  formatPrice,
} from "../../../utilities";
import "../LisenseRequest.scss";

const purposeOptions = ["Product Page (ecommerce)", "Website", "Advertisement"];

const mimeTypes = {
  ogm: "video/ogg",
  ogv: "video/ogg",
  ogg: "video/ogg",
  mp4: "video/mp4",
  webm: "video/webm",
};

class SendLicenseRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purposes: [],
      message: "",
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { dispatch, videoId } = this.props;
    dispatch(fetchVIPVideoNote(videoId));
  }

  componentWillUnmount() {
    this.props.dispatch(resetLicenseRequestVideo());
  }

  submit = () => {
    const {
      currentUser: { _id, first_name, last_name },
      currentBrandName,
      influencerNote: note,
      dispatch,
      licenseRequestVideo,
      influencerAdminId,
      influencerEmail,
      channel,
    } = this.props;
    const { message, purposes } = this.state;
    const data = {
      influencerId: influencerAdminId,
      videoId: licenseRequestVideo._id,
      purpose: purposes,
    };
    const { pubnub } = window;

    pubnub.publish({
      channel: "vyrill",
      message: {
        channel,
        user: [first_name, last_name].join(" "),
        user_id: _id,
      },
      storeInHistory: false,
    });
    dispatch(sendMessage(influencerAdminId));
    dispatch(
      sendLicenseRequest({
        data,
        message,
        channel,
        video: licenseRequestVideo,
        note,
      })
    );
  };

  addTag = (tag) => {
    this.setState(({ purposes }) =>
      purposes.includes(tag) ? { purposes } : { purposes: [...purposes, tag] }
    );
  };

  removeTag = (tag) => {
    this.setState(({ purposes }) => {
      const indexOfTag = purposes.indexOf(tag);
      if (indexOfTag === -1) {
        return { purposes };
      }
      const newPurposes = [...purposes];
      newPurposes.splice(indexOfTag, 1);
      return {
        purposes: newPurposes,
      };
    });
  };

  render() {
    const { licenseRequestVideo, influencerNote: note } = this.props;
    const {
      video_url,
      platform,
      title,
      video_embedded_url,
      _id,
      thumbnail_url,
    } = licenseRequestVideo || {};

    const { purposes, message } = this.state;

    return (
      <div className="license-request">
        <h1>
          <strong>Send a license request</strong>
        </h1>
        <div className="LicenseRequest-VideoContainer">
          {video_url && platform === "Dropbox" ? (
            <div className="LicenseRequest-VideoWrapper">
              <video
                id="video"
                className="LicenseRequest-VideoFrame"
                width="100%"
                height="auto"
                controls
              >
                <source
                  src={video_url.replace(
                    "www.dropbox.com",
                    "dl.dropboxusercontent.com"
                  )}
                  type={mimeTypes[title.split(".").pop()] || ""}
                />
                <p>Sorry, your browser doesn't support embedded videos.</p>
              </video>
            </div>
          ) : null}
          {video_embedded_url && platform === "Youtube" && (
            <div className="LicenseRequest-VideoWrapper">
              <div className="LicenseRequest-VideoFrame">
                <YouTubeVideo
                  videoId={video_embedded_url.match(/embed\/(.*)/)[1]}
                />
              </div>
            </div>
          )}
          {video_url && platform === "Tiktok" && (
            <div className="LicenseRequest-VideoWrapper">
              <GenerateTiktokThumbnail
                video={licenseRequestVideo}
                customStyle={{
                  display: "flex",
                  justifyContent: "center",
                  background: "black",
                  width: "600px",
                }}
                imgStyle={{
                  objectFit: "contain",
                  maxHeight: "350px",
                }}
              />
            </div>
          )}
          <h4>
            <strong>{title}</strong>
          </h4>
        </div>
        <h3>
          <strong>Creator priced this license at:</strong>
        </h3>
        <p>
          If you would like to request an edit to the length or price, you may
          ask the creator below
        </p>
        <div className="license-settings">
          <span className="license-duration">
            {getLicenseDuration(note)} license
          </span>
          <span className="license-price">
            {formatPrice(getLicensePrice(note))}
          </span>
        </div>
        <SelectableTags
          title="Select the purpose of the license"
          tagList={purposeOptions}
          selectedTags={purposes}
          name="purposes"
          select={this.addTag}
          unselect={this.removeTag}
        />
        <MySelect
          label="Other"
          optionList={[]}
          placeholder="Start Typing Tag"
          unselectTag={this.removeTag}
          name="purpose"
          addFromSelect={(options) => this.addTag(options[0].value)}
          tags={purposes.filter((purpose) => !purposeOptions.includes(purpose))}
        />
        <div className="chat-message-container">
          <label htmlFor="message">
            <b>Type your message:</b>
          </label>
          <textarea
            id="message"
            onChange={({ target: { value } }) =>
              this.setState({ message: value })
            }
            value={message}
          />
          <div className="license-buttons">
            <button
              type="button"
              onClick={this.submit}
              className="btn btn-primary mb-1"
            >
              Send license request
            </button>
            <span>
              You will not be charged at this time until creator accepts the
              offer.
            </span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  navbarStatsReducer: { current_user, currentBrand },
  licenseRequestVideo,
  vipInfluencerVideoNote,
}) => ({
  licenseRequestVideo,
  influencerNote: vipInfluencerVideoNote.body,
  currentUser: current_user,
  currentBrandName: currentBrand ? currentBrand.name : "",
});

export default connect(mapStateToProps)(SendLicenseRequest);
